module.exports = __webpack_public_path__ + "media/images/emoticons/apple-137c686be23c02d5232e63e6f9737221.gif";